import "./App.css";
import {
  BrowserRouter as Router,
  Routes,
  Route,
} from "react-router-dom";
import { ToastContainer } from "react-toastify";
import RegistrationForm from "./Components/RegistrationForm.tsx";
import Login from "./Components/Login.tsx";
import AdminPanel from "./Components/AdminPanel.tsx";
import AdminDashboardList from "./Components/AdminDashboardList.tsx";
import Timeline from "./Components/Timeline.tsx";
import Team from "./Components/Team.tsx";
import Project from "./Components/Project.tsx";
import { UserProvider } from "./Components/Context/UserContext.tsx";
import { EmployeeProvider } from "./Components/Context/EmployeeContext.tsx";
import { ProjectProvider } from "./Components/Context/ProjectContext.tsx";
import Client from "./Components/Client.tsx";
import AddTask from "./Components/AddTask.tsx";
import Tasklist from "./Components/Tasklist.tsx";
import DetailsReport from "./Components/DetailsReport.tsx";
import SummaryReport from "./Components/SummaryReport.tsx";
import UserDashboard from "./Components/UserDashboard.tsx";
import TasklistUser from "./Components/TasklistUser.tsx";
import Documenttation from "./Components/Documenttation.tsx";
import PrivateRoute from "./Components/CSS/PrivateRoute.tsx";
import ForgotpasswordEmail from "./Components/ForgotpasswordEmail.tsx";
import SetPassword from "./Components/SetPassword.tsx";

function App() {
  return (
    <UserProvider>
      <Router>
        <Routes>
          <Route path="/" element={<Documenttation />} />
          <Route path="/signup" element={<RegistrationForm />} />
          <Route path="/forgotpassword" element={<ForgotpasswordEmail />} />
          <Route path="/login" element={<Login />} />
          <Route path="/setpassword" element={<SetPassword />} />
          <Route path="/documentation" element={<Documenttation />} />
          <Route
            path="/User-dashboard"
            element={
              <PrivateRoute>
                <AdminPanel />
              </PrivateRoute>
            }
          >
            <Route
              path="UserprojectList"
              element={
                <PrivateRoute>
                  <UserDashboard />
                </PrivateRoute>
              }
            />
            <Route
              path="UserTaskList"
              element={
                <PrivateRoute>
                  <TasklistUser />
                </PrivateRoute>
              }
            />
          </Route>
          {/* <Route path="/admin-dashboard/" element={<AdminPanel />} /> */}
          <Route
            path="/admin-dashboard"
            element={
              <PrivateRoute>
                <AdminPanel />
              </PrivateRoute>
            }
          >
            {/* <Route path="profile" element={<Profile />} /> */}
            <Route
              path="activity-dashboard"
              element={
                <PrivateRoute>
                  <AdminDashboardList />
                </PrivateRoute>
              }
            />
            <Route
              path="timeline"
              element={
                <PrivateRoute>
                  <Timeline />
                </PrivateRoute>
              }
            />
            <Route
              path="client"
              element={
                <PrivateRoute>
                  <Client />
                </PrivateRoute>
              }
            />
            {/*  <Route path="team" element={<Team />} /> */}
            <Route
              path="AddTask"
              element={
                <PrivateRoute>
                  <AddTask />
                </PrivateRoute>
              }
            />
            <Route
              path="detailsReport"
              element={
                <PrivateRoute>
                  <DetailsReport />
                </PrivateRoute>
              }
            />
            <Route
              path="summaryreport"
              element={
                <PrivateRoute>
                  <SummaryReport />
                </PrivateRoute>
              }
            />
            <Route
              path="TaskList"
              element={
                <PrivateRoute>
                  <Tasklist />
                </PrivateRoute>
              }
            />
            <Route
              path="team"
              element={
                <PrivateRoute>
                  <EmployeeProvider>
                    <Team />
                  </EmployeeProvider>
                </PrivateRoute>
              }
            />
            <Route
              path="project"
              element={
                <PrivateRoute>
                  <ProjectProvider>
                    <Project />
                  </ProjectProvider>
                </PrivateRoute>
              }
            />
          </Route>
        </Routes>

        {/* Toastify container for toasts */}
        <ToastContainer
          position="top-center"
          autoClose={3000}
          hideProgressBar
          newestOnTop
          closeButton
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
          style={{
            fontSize: "16px", // Font size for all toasts
            fontFamily: "'Arial', sans-serif", // Custom font family
            borderRadius: "8px", // Rounded corners for all toasts
            padding: "15px", // Padding for all toasts
          }}
          toastStyle={{
            backgroundColor: "#333", // Default background color
            color: "#fff", // Default text color
          }}
        />
      </Router>
    </UserProvider>
  );
}

export default App;
